var waiterDom = require('./waiter.html');

class FintecturePaymentHandler {
  constructor(target, promoter_slug, reservation_id) {
    this.target = target;
    this.promoter_slug = promoter_slug;
    this.reservation_id = reservation_id;
  }

  startWaiting() {
    this.target.append($( waiterDom ));
    // this.refreshStatus();
    this.refreshStatusInterval = setInterval(() => { this.refreshStatus() }, 1000);
  }

  refreshStatus() {
    $.ajax({
      method: 'GET',
      url: `/api/${this.promoter_slug}/reservations/${this.reservation_id}`
    })
    .done((data) => {
      var resaData = data.reservation;
      console.log(resaData);
      if (resaData['status'] === 'cancelled') {
        window.location = resaData['reservation_url'];
      } else if (!_.isNil(resaData['payed_at'])) {
        const parser = new URL(window.location);
        parser.searchParams.delete('payment_pending');
        window.location = parser.href;
      }
    })
    .fail((e) => {
      console.log('error', e);
    });
  }
}

var buildFintecturePaymentHandler = function (options) {
  var settings = $.extend({
  }, options );
  var builder = new FintecturePaymentHandler($(this), $(this).data('promoter-slug'), $(this).data('reservation-id'));
  builder.startWaiting();

  return builder;
};

export default buildFintecturePaymentHandler;
